import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {
  initialize(){
    super.initialize();
    this.filter = document.querySelector('[data-controller="admin--index-filter"]');
    this.filterTriggerer = this.filter.querySelector('[data-admin--index-filter-target="filterTriggerer"]');
  }

  connect(){
    super.connect();
    // this.bindChangeDateFilter();
    this.bindFilter();
  }

  bindFilter(){
    this.filterTriggerer.addEventListener('click', (e) => {
      window.KTApp.blockPage();
      const params = [];

      const inputs = this.filter.querySelectorAll('input,select');
      for(let i=0 ;i<inputs.length; i++){
        if(inputs[i].type === 'radio'){
          if(inputs[i].checked){
            params.push({
              name: inputs[i].name,
              value: inputs[i].value
            });
          }
        } else if(inputs[i].tagName === 'SELECT'){
          if(inputs[i].hasAttribute('multiple')){
            const selectedValues = Array.prototype.slice.call(
              inputs[i].selectedOptions
            ).map((x) => {return x.value});
            params.push({
              name: inputs[i].name,
              value: selectedValues
            });
          } else {
            const selectedOption = inputs[i].selectedOptions[0]
            if(selectedOption){
              params.push({
                name: inputs[i].name,
                value: selectedOption.value
              });
            }
          }
        } else if(inputs[i].type === 'checkbox'){
          if(!inputs[i].checked){
            continue;
          }

          const a = params.filter((x) => {return x.name == inputs[i].name})[0]
          if(a){
            a.value.push(inputs[i].value);
          } else {
            params.push({
              name: inputs[i].name,
              value: [inputs[i].value]
            });
          }

        } else {
          params.push({
            name: inputs[i].name,
            value: inputs[i].value
          });
        }
      }

      if(params.length > 0){
        params.forEach((entry) => {
          this.datatable.setDataSourceParam(entry.name, entry.value);
          this.datatable.load();
        });
      }

      window.KTApp.unblockPage();
      this.filter.click();
    });
  }

  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'name',
        title: 'Nama',
        width: 150,
        template: function(data) {
          return `<a href="${data.show_path}" class="font-weight-bolder text-secondary">${data.name}</a>`;
        }
      },
      {
        field: 'category_name',
        title: 'Kategori',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.category_name}</span>`;
        }
      },
      {
        field: 'learning_name',
        title: 'Nama Materi Belajar Pajak',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.learning_name}</span>`;
        }
      },
      {
        field: 'tags',
        title: 'Tag',
        sortable: false,
        template: function(data) {
          if(!data.tags){
            return;
          }
          const res = data.tags.map(x => {
            return `
              <span
                class="label label-primary label-inline font-weight-lighter mr-2 h-auto"
              >
                ${x}
              </span>
            `;
          });
          return `<span class="font-weight-bolder">${res.join('')}</span>`;
        }
      },
      {
        field: 'is_free',
        title: 'Video Gratis?',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.is_free ? 'Ya' : 'Tidak'}</span>`;
        }
      },
      {
        field: 'total_feedback',
        title: 'Feedback',
        sortable: false,
        template: function(data) {
          return `
          <span class="font-weight-bolder">
            <i class="far fa-thumbs-up mr-5">
              ${data.like_count}
            </i>
            <i class="far fa-thumbs-down">
              ${data.dislike_count}
            </i>
          </span>
          `;
        }
      },
      {
        field: 'description',
        title: 'Description',
        width: 200,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.description}</span>`;
        }
      },
      {
        field: 'created_at',
        title: 'Tanggal Dibuat',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.created_at}</span>`;
        }
      },
      {
        field: 'Actions',
        title: 'Actions',
        sortable: false,
        width: 120,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.show_path}" title="Tampilkan">
              <i class="fa fa-eye text-primary"></i>
            </a>
            <a href="${data.delete_path}" data-method="delete" data-confirm="Apakah anda yakin ingin menghapus akun ini?" class="btn btn-sm btn-clean btn-icon" title="Delete">
              <i class="la la-trash text-danger"></i>
            </a>
          `;
        },
      }
    ]
  }
}
